import React from 'react';
import type { CodeRef } from './CodeReferencesPanel';

export type CodeReferencesUiContextValue = {
  refs: CodeRef[];
  scopeId: string;
};

export const CodeReferencesUiContext = React.createContext<CodeReferencesUiContextValue | null>(null);
